import React from "react";
import { useReportContent } from "./ReportContentProvider";

function clip(value, max = 500) {
  return String(value || "").replace(/\s+/g, " ").trim().slice(0, max);
}

export default function ReportContentButton({
  targetType,
  targetId,
  title = "",
  contentSnippet = "",
  url = "",
  meta = {},
  className = "",
  children = "Пожаловаться",
  compact = false,
  stopPropagation = true,
  ...props
}) {
  const { openReport } = useReportContent();

  const handleClick = React.useCallback(
    (event) => {
      if (stopPropagation) {
        event.preventDefault();
        event.stopPropagation();
      }
      openReport({
        targetType,
        targetId,
        title: clip(title, 180),
        contentSnippet: clip(contentSnippet, 800),
        url,
        meta,
      });
    },
    [contentSnippet, meta, openReport, stopPropagation, targetId, targetType, title, url]
  );

  return (
    <button
      type="button"
      className={`report-content-btn${compact ? " report-content-btn--compact" : ""}${className ? ` ${className}` : ""}`}
      onClick={handleClick}
      aria-label={typeof children === "string" ? children : "Пожаловаться"}
      {...props}
    >
      <span className="report-content-btn__icon" aria-hidden="true">⚑</span>
      <span className="report-content-btn__label">{children}</span>
    </button>
  );
}
